import * as React from 'react'
import { connectStateResults, StateResultsProvided } from 'react-instantsearch-core'

import { ITab } from '.'
import { ITranslationsProvided, PrefixTranslations, withTranslations } from '../../../connectors/translation'
import { AnyHit } from '../hits'
import { AnyHitBlockView } from '../hits/any-hit'
import ConnectedHrefModifier from '../href-modifier'
import { ConnectedDesktopTabLayout, ConnectedMobileTabLayout } from './layout'
import { BlockTabView } from './views/block'
import { TableTabView } from './views/table'
import { isEmpty, isMobile } from './views/utils'
import { HiddenAttributesForFaceting } from '../hidden-attributes-for-faceting'
import { AlgoliaSearchOptions } from 'algoliasearch'
import WCC from 'wcc'
export interface IProps {
  tab: ITab
  initial: boolean
  messagesOnly?: boolean
  autosuggestIndex?: string
  autoFocus?: boolean
  /** Callback invoked when the portal target element becomes available */
  onPortalReady?: (domNode: HTMLElement) => void
}

export interface IState {
  /** Tracks whether the portal ready notification has been sent */
  notifiedPortalReady: boolean
}

// TODO: https://github.com/watermarkchurch/paper-signs/issues/297 pass translations down
const TabViews: { [key: string]: React.ComponentType<Record<string, never>> } = {
  default: TableTabView,
  table: TableTabView,
  block: BlockTabView,
}

const opts: AlgoliaSearchOptions = {
  logger: console as any,
}
if (WCC.algoliaProxy) {
  Object.assign(opts, {
    hosts: [WCC.algoliaProxy],
  })
}

class TabViewSwitch extends React.PureComponent<IProps & ITranslationsProvided & StateResultsProvided<AnyHit>, IState> {
  state: IState = { notifiedPortalReady: false }

  componentDidUpdate() {
    const { notifiedPortalReady } = this.state
    const portal = document.getElementById('messages-only-search-box-portal')
    if (portal && this.props.onPortalReady && !notifiedPortalReady) {
      this.setState({ notifiedPortalReady: true })
      this.props.onPortalReady(portal)
    }
  }

  public render() {

    if (!this.isCorrectIndex()) {
      return null
    }

    const { tab, initial, messagesOnly } = this.props

    if (initial) {
      // Use layout in the future?
      return this.renderInitialHit()
    }

    const view = isMobile() ? (tab.mobile_view || tab.view) : tab.view
    const Template = TabViews[view] || TabViews.default

    const Layout = isMobile() ?
      ConnectedMobileTabLayout :
      ConnectedDesktopTabLayout

    return <PrefixTranslations prefix={['tabs', tab.name]}>
      <Layout messagesOnly={messagesOnly} tab={tab} initial={initial}
      // initialHit={this.renderInitialHit()}
      >
        <HiddenAttributesForFaceting attributes={tab.hidden_attributes_for_faceting} />
        <div className="justify-content-center justify-content-md-start d-flex site-search-hits">
          <ConnectedHrefModifier className="w-100">
            <Template />
          </ConnectedHrefModifier>
        </div>
      </Layout>
    </PrefixTranslations>
  }

  private renderInitialHit() {
    const { tab, searchResults } = this.props

    const hasInitialQuery = !isEmpty(tab.initial_hit)
    if (hasInitialQuery) {
      if (!searchResults.hits[0]) {
        return null
      }

      const hit = searchResults.hits[0] as AnyHit

      return <div className="block-view">
        <AnyHitBlockView hit={hit} thumbPosition={'bottom'} />
      </div>
    } else {
      return null
    }
  }

  private isCorrectIndex(): boolean {
    const { tab, searchResults } = this.props

    if (!searchResults) { return false }
    if (tab.index == searchResults.index) { return true }
    if (!tab.indexes) { return false }
    return tab.indexes.some((i) => i.id == searchResults.index)
  }

}

const ConnectedTabViewSwitch = connectStateResults(withTranslations(TabViewSwitch)
)
export default ConnectedTabViewSwitch
